
// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Your Firebase configuration object

const firebaseConfig = {
    apiKey: "AIzaSyDiFUBjlCJQSENvoODS0Hgi9cFah26h3wA",
    authDomain: "cakeplusart-cad86.firebaseapp.com",
    projectId: "cakeplusart-cad86",
    storageBucket: "cakeplusart-cad86.appspot.com",
    messagingSenderId: "367788111507",
    appId: "1:367788111507:web:0a00f207f5b8110151ff66",
    measurementId: "G-74LHL7CPWW"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };

